import React from 'react';

const Success = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "29",
    height: "29",
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.5603 0.311279C18.2637 0.311279 21.8154 1.78244 24.4341 4.40113C27.0528 7.01982 28.524 10.5715 28.524 14.2749C28.524 17.9783 27.0528 21.53 24.4341 24.1487C21.8154 26.7674 18.2637 28.2386 14.5603 28.2386C10.8569 28.2386 7.30522 26.7674 4.68653 24.1487C2.06784 21.53 0.59668 17.9783 0.59668 14.2749C0.59668 10.5715 2.06784 7.01982 4.68653 4.40113C7.30522 1.78244 10.8569 0.311279 14.5603 0.311279ZM12.8208 17.0297L9.71892 13.9258C9.60772 13.8146 9.4757 13.7264 9.33041 13.6662C9.18512 13.606 9.02939 13.5751 8.87213 13.5751C8.71486 13.5751 8.55914 13.606 8.41385 13.6662C8.26855 13.7264 8.13654 13.8146 8.02533 13.9258C7.80075 14.1504 7.67458 14.455 7.67458 14.7726C7.67458 15.0902 7.80075 15.3948 8.02533 15.6194L11.975 19.5691C12.0859 19.6809 12.2179 19.7696 12.3632 19.8301C12.5085 19.8907 12.6644 19.9218 12.8218 19.9218C12.9793 19.9218 13.1352 19.8907 13.2805 19.8301C13.4258 19.7696 13.5577 19.6809 13.6686 19.5691L21.8473 11.3884C21.96 11.2777 22.0497 11.1457 22.1111 11.0002C22.1725 10.8546 22.2046 10.6983 22.2053 10.5403C22.206 10.3823 22.1755 10.2258 22.1154 10.0796C22.0553 9.93351 21.9669 9.80073 21.8552 9.68894C21.7436 9.57716 21.6109 9.48858 21.4649 9.42833C21.3188 9.36808 21.1623 9.33734 21.0043 9.33789C20.8463 9.33844 20.6899 9.37026 20.5443 9.43153C20.3987 9.49279 20.2666 9.58228 20.1557 9.69484L12.8208 17.0297Z",
      fill: "#00B74A"
    }
  )
);

export { Success };
//# sourceMappingURL=Success.js.map
